
var ElpData = [
  {
    Pathname: "/elp1",
    Title: "Title 101",
    Header: "What is Title Insurance",
    SubHeader: "and Why Do I Need It?",
    Description: "",
    Navigation_title: `On this page`,
    Section: [
      {
        Title: "What is title insurance and why should I get it?",
        RichText: [
          
          {
            Type: "list",
            Text: [
              "Owner’s title insurance protects your equity in the property up to the amount of your purchase price",
              "Lender’s title insurance— which is required by most banks and other mortgage lenders — protects the lender up to the amount of the loan they provided",
            ],
          },
         
          {
            Type: "paragraph",
            Text:
              "You’re in control when you choose Radian Title Direct. Our reliable digital title and settlement platform gets you a quote in under 60 seconds, shows you your expected savings and helps you get to the final stages of homebuying quickly and confidently.",
          },
        ],
        CTA: "Get a Quote in 60 Seconds",
      },
      {
        Title: "Can I shop around for title insurance?",
        RichText: [
          {
            Type: "paragraph",
            Text:
              "You can shop for title insurance whenever you want, but we recommend you start shopping very early in the process of buying, selling or refinancing a home. Some title insurance providers can provide you with a cheaper rate, but won’t be able to take you on as a client if your expected closing date is too soon.",
          },
        ],
        CTA: "Get a Quote in 60 Seconds",
      },
      {
        Title: "What will title insurance protect me from exactly?",
        RichText: [
          {
            Type: "paragraph",
            Text:
              "Before you purchased your home, it may have gone through several ownership changes – and the land it's built on went through many more. Someone along the way may have forged a signature in transferring title or not paid real estate taxes.",
          },
          {
            Type: "list",
            Text: [
              "Undisclosed liens",
              "Fraud",
              "Undisclosed easements",
              "Possible lawsuits",
            ],
          },
          {
            Type: "paragraph",
            Text:
              "A title company like Radian Title will perform a title search and issue a title insurance policy that reflects your needs. Then, together with your real estate agent, we’ll ensure the closing process goes smoothly and get you covered.",
          },
        ],
        CTA: "Learn More About Policies",
      },
      {
        Title: "Why do I need title insurance if a search found no issues?",
        RichText: [
          {
            Type: "paragraph",
            Text:
              "A title search involves researching public records and legal documents for any events that could affect property ownership, such as:",
          },

          {
            Type: "list",
            Text: [
              "Deaths",
              "Divorces",
              "Court judgements",
              "Liens",
              "Taxes",
              "Wills",
            ],
          }
        ],
      },
      {
        Title: "Who pays for title insurance?",
        RichText: [
          {
            Type: "paragraph",
            Text: "It depends.",
          },
          {
            Type: "paragraph",
            Text:
              "Local regulations dictate whether the buyer or seller pays for the premium, but sometimes sellers and buyers negotiate who will pay for it and other closing costs. If you’re unsure, talk to your real estate agent about what’s typical in your area and the options you have.",
          },
        ],
      },
      {
        Title: "Do I have to purchase title insurance?",
        RichText: [
          {
            Type: "paragraph",
            Text:
              "If you’re paying cash for a home, you don't have to purchase owner’s title insurance, but it is highly recommended by experts because it protects your equity in the property.",
          },
          {
            Type: "paragraph",
            Text:
              "If you’re getting a loan or mortgage, a vast majority of banks and other mortgage lenders require that you get lender’s title insurance equal to the loan amount. But that only protects the lender’s stake in the property — not your investment.",
          }
        ],
        CTA: "See Your Savings",
      },
    ],
    
  }
];

export { ElpData };
